"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _theme = _interopRequireDefault(require("../../theme"));
const useStyles = (0, _core.makeStyles)({
  root: {
    display: 'flex',
    padding: '25px',
    position: 'relative',
    justifyContent: 'space-between',
    [_theme.default.breakpoints.up('lg')]: {
      padding: '25px 65px'
    }
  }
});
var _default = exports.default = useStyles;